import { render } from "./quota.vue?vue&type=template&id=228edba4&scoped=true"
import script from "./quota.vue?vue&type=script&lang=js"
export * from "./quota.vue?vue&type=script&lang=js"

import "./quota.vue?vue&type=style&index=0&id=228edba4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-228edba4"

export default script